export const images = {
  narwhal:
    "https://isfnr.org/wp-content/uploads/2025/05/Screenshot-2025-05-30-at-12.18.27.png",
  brickWall:
    "https://isfnr.org/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-30-at-12.22.00.jpeg",
  darkWall:
    "https://isfnr.org/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-30-at-12.22.14.jpeg",
  lightWall:
    "https://isfnr.org/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-30-at-12.21.35.jpeg",
  blurBackground:
    "https://isfnr.org/wp-content/uploads/2025/05/Screenshot-2025-05-31-at-15.14.05.png",
  flyer:
    "https://isfnr.org/wp-content/uploads/2025/06/Screenshot-2025-06-02-at-13.25.50.png",
  streetPhoto:
    "https://isfnr.org/wp-content/uploads/2025/06/KRI_grjotathorpid_240529_001-scaled.jpg",
};
